if (!customElements.get('m-compre-junto')) {
  class MCompreJunto extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.modal = this.querySelector('[data-compre-junto-modal]');
      this.openButton = this.querySelector('[data-compre-junto-open]');
      this.submitButton = this.querySelector('[data-compre-junto-submit]');
      this.errorWrapper = this.querySelector('[data-compre-junto-error]');
      this.cartDrawer = document.querySelector('m-cart-drawer');
      this.isSubmitting = false;

      if (!this.modal || !this.openButton || !this.submitButton) return;

      this.portalModal();
      this.bindEvents();
      this.initializePickers();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleKeydown);

      if (this.modal?.parentElement === document.body) {
        this.appendChild(this.modal);
      }
    }

    portalModal() {
      if (this.modal.parentElement !== document.body) {
        document.body.appendChild(this.modal);
      }
    }

    getItems() {
      return this.modal.querySelectorAll('[data-compre-junto-item]');
    }

    getPickers() {
      return this.modal.querySelectorAll('[data-compre-junto-variant-picker]');
    }

    bindEvents() {
      this.openButton.addEventListener('click', () => this.open());
      this.submitButton.addEventListener('click', () => this.addAllToCart());

      this.modal.querySelectorAll('[data-compre-junto-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      this.handleKeydown = (event) => {
        if (event.key === 'Escape') this.close();
      };

      this.getPickers().forEach((picker) => {
        picker.addEventListener('change', () => this.updatePickerVariant(picker));
      });
    }

    initializePickers() {
      this.getPickers().forEach((picker) => {
        this.updatePickerVariant(picker);
      });
    }

    open() {
      this.portalModal();
      this.syncMainProductVariant();
      this.modal.hidden = false;
      requestAnimationFrame(() => {
        this.modal.classList.add('is-active');
      });
      document.documentElement.classList.add('prevent-scroll');
      document.body.classList.add('m-compre-junto-open');
      document.addEventListener('keydown', this.handleKeydown);
    }

    close() {
      this.modal.classList.remove('is-active');
      document.documentElement.classList.remove('prevent-scroll');
      document.body.classList.remove('m-compre-junto-open');
      document.removeEventListener('keydown', this.handleKeydown);

      setTimeout(() => {
        this.modal.hidden = true;
        this.openButton.focus();
      }, 300);
    }

    getVariantsFromPicker(picker) {
      const variantsScript = picker.querySelector('[data-product-variants]');
      if (!variantsScript) return [];

      try {
        return JSON.parse(variantsScript.textContent);
      } catch (error) {
        console.error('Compre junto variants parse error:', error);
        return [];
      }
    }

    getSelectedOptionsFromPicker(picker) {
      const selectedOptions = [];

      picker.querySelectorAll('.m-product-option').forEach((group) => {
        const select = group.querySelector('select');
        if (select) {
          selectedOptions.push(select.value);
          return;
        }

        const checked = group.querySelector('input[type="radio"]:checked');
        if (checked) {
          selectedOptions.push(checked.value);
        }
      });

      return selectedOptions;
    }

    resolveVariantFromPicker(picker) {
      const variants = this.getVariantsFromPicker(picker);
      const selectedOptions = this.getSelectedOptionsFromPicker(picker);

      if (!variants.length || !selectedOptions.length) return null;

      return (
        variants.find((variant) =>
          variant.options.every((option, index) => option === selectedOptions[index])
        ) || null
      );
    }

    updatePickerVariant(picker) {
      const variant = this.resolveVariantFromPicker(picker);
      const hiddenInput = picker.querySelector('[data-compre-junto-variant]');
      const item = picker.closest('[data-compre-junto-item]');

      if (!hiddenInput) return;

      picker.querySelectorAll('.m-product-option').forEach((group) => {
        const labelSelected = group.querySelector('.option-label--selected');
        const select = group.querySelector('select');

        if (select && labelSelected) {
          labelSelected.textContent = select.value;
          return;
        }

        const checked = group.querySelector('input[type="radio"]:checked');
        if (checked && labelSelected) {
          labelSelected.textContent = checked.value;
        }
      });

      if (!variant) {
        hiddenInput.value = '';
        hiddenInput.disabled = true;
        return;
      }

      hiddenInput.value = variant.id;
      hiddenInput.dataset.price = variant.price;
      hiddenInput.disabled = !variant.available;

      if (item) {
        this.updateItemPriceFromVariant(item, variant);
      }
    }

    updateItemPriceFromVariant(item, variant) {
      const priceEl = item.querySelector(
        '[data-compre-junto-price] .m-price-item--regular, [data-compre-junto-price] .price__regular, [data-compre-junto-price] .price-per-item--current'
      );

      if (priceEl && window.formatMoney) {
        priceEl.textContent = formatMoney(variant.price, window.MinimogSettings.money_format);
      }
    }

    setPickerToVariant(picker, variantId) {
      const variants = this.getVariantsFromPicker(picker);
      const variant = variants.find((entry) => String(entry.id) === String(variantId));

      if (!variant) return;

      picker.querySelectorAll('.m-product-option').forEach((group, index) => {
        const value = variant.options[index];
        const select = group.querySelector('select');

        if (select) {
          select.value = value;
          return;
        }

        const radios = group.querySelectorAll('input[type="radio"]');
        radios.forEach((radio) => {
          radio.checked = radio.value === value && !radio.disabled;
        });
      });

      this.updatePickerVariant(picker);
    }

    syncMainProductVariant() {
      const mainItem = this.modal.querySelector('[data-is-main-product="true"]');
      if (!mainItem) return;

      const picker = mainItem.querySelector('[data-compre-junto-variant-picker]');
      const variantInput = document.querySelector(`#product-form-${this.sectionId} [name="id"]`);

      if (!picker || !variantInput?.value) return;

      this.setPickerToVariant(picker, variantInput.value);
    }

    collectCartItems() {
      const seenVariantIds = new Set();
      const cartItems = [];

      [...this.getItems()]
        .filter((item) => item.dataset.available === 'true')
        .forEach((item) => {
          const variantField = item.querySelector('[data-compre-junto-variant]');
          if (!variantField || variantField.disabled) return;

          const variantId = variantField.value;
          if (!variantId || seenVariantIds.has(variantId)) return;

          seenVariantIds.add(variantId);
          cartItems.push({ id: variantId, quantity: 1 });
        });

      return cartItems;
    }

    async addVariantToCart(variantId, quantity, includeSections) {
      let sectionsToBundle = [];

      if (includeSections) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
      }

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      if (includeSections) {
        formData.append('sections', sectionsToBundle);
        formData.append('sections_url', window.location.pathname);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const response = await fetch(window.MinimogSettings.routes.cart_add_url, config);

      if (!response.ok) {
        if (response.status === 429) {
          throw new Error('Muitas tentativas em sequência. Aguarde alguns segundos e tente novamente.');
        }
        throw new Error(`Erro ${response.status} ao adicionar ao carrinho.`);
      }

      const data = await response.json();

      if (data.status) {
        throw new Error(data.description || 'Não foi possível adicionar os produtos ao carrinho.');
      }

      return data;
    }

    async addAllToCart() {
      if (this.isSubmitting) return;

      const cartItems = this.collectCartItems();
      if (!cartItems.length) {
        this.showError(window.MinimogStrings?.selectVariant || 'Selecione as variantes disponíveis.');
        return;
      }

      this.isSubmitting = true;
      this.toggleLoading(true);
      this.clearError();

      const { MinimogSettings, MinimogStrings } = window;

      try {
        let lastResponse = null;

        for (let index = 0; index < cartItems.length; index += 1) {
          const isLastItem = index === cartItems.length - 1;
          lastResponse = await this.addVariantToCart(cartItems[index].id, cartItems[index].quantity, isLastItem);

          if (!isLastItem) {
            await new Promise((resolve) => setTimeout(resolve, 300));
          }
        }

        this.close();

        if (MinimogSettings.use_ajax_atc) {
          window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: lastResponse });

          if (this.cartDrawer && MinimogSettings.enable_cart_drawer) {
            MinimogTheme.Notification.show({
              target: this.cartDrawer.querySelector('m-cart-items'),
              method: 'prepend',
              type: 'success',
              message: MinimogStrings.itemAdded,
              delay: 400,
            });

            requestAnimationFrame(() => {
              this.cartDrawer.open(this.submitButton);
            });
          } else {
            MinimogTheme.Notification.show({
              target: this.errorWrapper || document.body,
              method: 'appendChild',
              type: 'success',
              message: MinimogStrings.itemAdded,
              last: 3000,
              sticky: !this.errorWrapper,
            });
          }

          document.dispatchEvent(
            new CustomEvent('product-ajax:added', {
              detail: { product: lastResponse },
            })
          );
        } else {
          window.location = MinimogSettings.routes.cart;
        }
      } catch (error) {
        console.error('Compre junto add to cart error:', error);
        this.showError(error.message || 'Ocorreu um erro ao adicionar os produtos ao carrinho.');
      } finally {
        this.isSubmitting = false;
        this.toggleLoading(false);
      }
    }

    showError(message) {
      if (!this.errorWrapper) return;

      MinimogTheme.Notification.show({
        target: this.errorWrapper,
        method: 'appendChild',
        type: 'warning',
        message,
      });
    }

    clearError() {
      if (this.errorWrapper) {
        this.errorWrapper.innerHTML = '';
      }
    }

    toggleLoading(loading) {
      this.submitButton.classList.toggle('m-spinner-loading', loading);
      this.openButton.disabled = loading;
      this.submitButton.disabled = loading;
    }
  }

  customElements.define('m-compre-junto', MCompreJunto);
}
